import PropTypes from 'prop-types';
import { Box } from 'roo-ui/components';
import { PaymentTable, PaymentTableBody, PaymentTableRow, PaymentTableHeader, PaymentTableData } from './primitives';
import { H2 } from '../primitives';
import Money from './Money';

const PAYMENT_TYPE = {
  credit_card: 'Credit Card',
  points: 'Qantas Points redeemed',
  voucher: 'Voucher',
};

const PaymentSummary = ({ breakdown }) => (
  <Box as="article">
    <H2>Payment Summary</H2>
    <PaymentTable>
      <PaymentTableBody data-hj-suppress>
        {breakdown.map(({ method, total }) => (
          <PaymentTableRow key={`payment_by_${method}`}>
            <PaymentTableHeader>{PAYMENT_TYPE[method]}</PaymentTableHeader>
            <PaymentTableData>
              <Money {...total} />
            </PaymentTableData>
          </PaymentTableRow>
        ))}
      </PaymentTableBody>
    </PaymentTable>
  </Box>
);

PaymentSummary.propTypes = {
  breakdown: PropTypes.array.isRequired,
};

export default PaymentSummary;
